module.exports = __webpack_public_path__ + "img/clicSocial-logo.fb4fa184.svg";